import React from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import {
  closeFacebookDomainVerificationModal,
  patchMetaTag,
  startSyncingProductValidationFlow,
  onChangeFacebookDomainVerification,
} from 'actions/onlineStore';
import styles from './FacebookDomainVerificationModal.css';

class FacebookDomainVerificationModal extends React.Component {
  constructor() {
    super();
    this.state = {
      metaTag: '',
      buttonDisabled: true,
    };
  }

  render() {
    const {
      businessInfo,
      isDomainVerificationModalOpened,
      domainVerificationError,
      domainVerificationStep,
    } = this.props;
    const { buttonDisabled } = this.state;
    const goStoreUrl =
      businessInfo !== null ? businessInfo.go_store_brand_page_url : '';
    const goStoreUrlText = goStoreUrl.replace('https://', '');

    return (
      <Modal
        show={isDomainVerificationModalOpened}
        onHide={this._handleHide}
        backdrop="static"
        keyboard={false}
        dialogClassName={styles['domain-verification-modal']}
      >
        <Modal.Header closeButton>
          <Modal.Title>Domain Verification</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className={styles['body-title']}>
            <p>
              <b>Verify Your GoStore Domain</b>
            </p>
            <p>
              One last step! Verify your GoStore domain using a code generated
              by Facebook. Follow the step by step below.
            </p>
          </div>
          <div className={styles['body-form']}>
            <div className={`row ${styles['body-form-middle']}`}>
              {domainVerificationStep === 2 &&
              domainVerificationError === null ? (
                <div>
                  <p className={styles['step-title']}>
                    <b>Step 2</b>
                  </p>
                  <div className="col-md-4">
                    <ol>
                      <li>
                        Go back to Facebook Domain page, on{' '}
                        <b>Meta-tag Verification</b> tab
                      </li>
                      <li>
                        Click <b>"Verify"</b> button, and all set!
                      </li>
                    </ol>
                  </div>
                </div>
              ) : (
                <div>
                  <p className={styles['step-title']}>
                    <b>Step 1</b>
                  </p>
                  <div className="col-md-4">
                    <ol>
                      <li>
                        Login to Facebook Business manager and go to{' '}
                        <a
                          target="_blank"
                          href="https://business.facebook.com/settings/owned-domains"
                        >
                          domain page
                        </a>
                      </li>
                      <li>
                        Click <b>"Add</b> button to create a new domain
                      </li>
                      <li>
                        Enter your GoStore domain URL (
                        <a target="_blank" href={goStoreUrl}>
                          {goStoreUrlText}
                        </a>
                        ) and click Add Domain
                      </li>
                      <li>
                        Go to <b>Meta-tag Verification</b> tab
                      </li>
                      <li>
                        <b>Copy the code</b> starting from "&lt;" until "&gt;"
                      </li>
                      <li>
                        <b>Paste the code on the box below</b>
                      </li>
                      <input
                        type="text"
                        maxLength="100"
                        className="form-control"
                        placeholder="Paste the meta-tag code..."
                        onChange={this._onChange}
                        value={this.state.metaTag}
                      />
                      <p className={styles['text-error']}>
                        {domainVerificationError !== null
                          ? domainVerificationError
                          : ''}
                      </p>
                    </ol>
                  </div>
                </div>
              )}
              <div className="col-md-8">
                <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/eFQfjPNkTSE?rel=0"
                  frameBorder="0"
                  allowFullScreen
                />
              </div>
            </div>
            <div className="row">
              {domainVerificationStep === 2 &&
              domainVerificationError === null ? (
                <div className={`col-md-12 ${styles['btn-action']}`}>
                  <button
                    className="btn btn-default"
                    type="button"
                    onClick={this._handleBack}
                  >
                    Back
                  </button>
                  <button
                    className="btn btn-primary"
                    type="button"
                    onClick={this._handleConfirm}
                  >
                    Confirm
                  </button>
                </div>
              ) : (
                <div className={`col-md-12 ${styles['btn-action']}`}>
                  <button
                    className="btn btn-primary"
                    type="button"
                    onClick={this._handleNext}
                    disabled={buttonDisabled}
                  >
                    Next
                  </button>
                </div>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <p>
            Having trouble following the steps? contact us via{' '}
            <a target="_blank" href="https://bit.ly/BertanyaGoStoreA">
              Whatsapp
            </a>{' '}
            or{' '}
            <a target="_blank" href="https://mokaposhelp.zendesk.com/hc/id">
              help center
            </a>
          </p>
        </Modal.Footer>
      </Modal>
    );
  }

  _onChange = e => {
    const metaTag = e.target.value;
    const regex = /<meta name="facebook-domain-verification" content="(.*?)"/gi;

    const match = regex.exec(metaTag);
    const buttonDisabled = match === null;

    this.setState({
      metaTag,
      buttonDisabled,
    });
  };

  _handleNext = () => {
    const { metaTag } = this.state;
    const metaTagName = 'facebook-domain-verification';
    const regex = /<meta name="facebook-domain-verification" content="(.*?)"/gi;

    const match = regex.exec(metaTag);

    if (match === null) {
      this.props.dispatch(
        onChangeFacebookDomainVerification({
          error: 'Invalid code, please check again',
        })
      );
    } else {
      const metaTagContent = match[1];
      this.props.dispatch(patchMetaTag(metaTagName, metaTagContent));
    }
  };

  _handleBack = () => {
    this.props.dispatch(onChangeFacebookDomainVerification({ step: 1 }));
  };

  _handleConfirm = () => {
    const { selectedShop } = this.props;

    if (selectedShop !== null && selectedShop !== undefined) {
      this.props.dispatch(
        startSyncingProductValidationFlow(selectedShop.id, false)
      );
    }

    this.props.dispatch(closeFacebookDomainVerificationModal());
    this._resetState();
  };

  _handleHide = () => {
    this.props.dispatch(closeFacebookDomainVerificationModal());
    this._resetState();
  };

  _resetState = () => {
    this.state = {
      metaTag: '',
      buttonDisabled: true,
    };
  };
}

function mapStateToProps(state) {
  const { facebook, shop } = state.onlineStore;

  return {
    businessInfo: shop.businessInfo,
    isDomainVerificationModalOpened: facebook.isDomainVerificationModalOpened,
    selectedShop: facebook.selectedShop,
    domainVerificationError: facebook.domainVerificationError,
    domainVerificationStep: facebook.domainVerificationStep,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FacebookDomainVerificationModal);
